import axios from 'axios'

export const SET_PAGE = 'SET_PAGE';
export const SET_LATEST = 'SET_LATEST';
export const SET_CURRENT = 'SET_CURRENT';

export const SET_STEP = 'SET_STEP';
export const SET_INFO = 'SET_INFO';
export const SET_FINANCE = 'SET_FINANCE';
export const SET_DOC = 'SET_DOC';

export const UPDATE_FORM = 'UPDATE_FORM';

export const FETCH_RESPONSE_SUCCESS = 'FETCH_RESPONSE_SUCCESS';
export const FETCH_RESPONSE_FAILED = 'FETCH_RESPONSE_FAILED';

export const RESET_FORM_RESPONSE = 'RESET_FORM_RESPONSE';

export const setCurrent = (currentstep) => {
    return {
        type: SET_CURRENT,
        payload: currentstep
    }
}
export const setLatest = (lateststep) => {
    return {
        type: SET_LATEST,
        payload: lateststep
    }
}
export const setPage = (page) => {
    return {
        type: SET_PAGE,
        payload: page
    }
}

export const setStep = (step) => {
    return {
        type: SET_STEP,
        payload: step
    }
}
export const setInfo = (infostep) => {
    return {
        type: SET_INFO,
        payload: infostep
    }
}
export const setFinance = (financestep) => {
    return {
        type: SET_FINANCE,
        payload: financestep
    }
}
export const setDoc = (doc) => {
    return {
        type: SET_DOC,
        payload: doc
    }
}

export const updateForm = (stateType, value) => {
    return {
        type: UPDATE_FORM,
        payload: {
            stateType,
            value
        }
    }
}

export const fetchResponseSuccess = (data) => {
    return {
        type: FETCH_RESPONSE_SUCCESS,
        payload: data
    }
}

export const fetchResponseFailed = () => {
    return {
        type: FETCH_RESPONSE_FAILED
    }
}

const resetFormResponse = () => {
    return {
        type: RESET_FORM_RESPONSE
    }
}

export const fetchResponse = () => {
	return (dispatch, getState) => new Promise((resolve,reject) => {
    dispatch(resetFormResponse());
		axios.get(`http://localhost:8888/mkwp/wp-json/jwt-auth/v1/token`)
  		.then((response) => {
    		dispatch(fetchResponseSuccess(response.data));
        resolve();
  		})
  		.catch((error) => {
        dispatch(fetchResponseFailed());
  			reject();
      })
	})
}



// WEBPACK FOOTER //
// ./src/store/actions/FormAction.js